"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useState } from "react";
export default function CompanyHistory() {
  const {
    ref: section1Ref,
    isVisible: section1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: section2Ref,
    isVisible: section2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: section3Ref,
    isVisible: section3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const timelineData = [{
    year: "2018",
    title: "Foundation",
    description: "West Indian Mining Company was founded to address the environmental challenge of stranded and vented methane from oil and gas production in the Caribbean region. The company pioneered mobile Bitcoin mining infrastructure designed to capture and repurpose wasted energy resources.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1545031/img/methane_capture_site_infrastructure.png"
  }, {
    year: "2020",
    title: "Infrastructure Evolution",
    description: "Advanced deployment of immersion-cooled mining systems marked a significant technical milestone. These systems delivered superior energy efficiency and thermal management, reducing operational costs while minimizing carbon impact across all facilities.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1545031/img/immersion_cooled_server_array.png"
  }, {
    year: "2023",
    title: "Strategic Expansion",
    description: "Formation of WIMCO Digital expanded operational capabilities into systematic digital asset strategies. The company integrated disciplined risk management frameworks and institutional governance standards, establishing a comprehensive infrastructure and trading platform.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1545031/img/modern_trading_desk_operations.png"
  }];
  return <section id="company-history" className="bg-background text-foreground py-[var(--spacing-xl)] px-[var(--spacing-md)] lg:px-[var(--spacing-xl)]">
      <div className="container mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-2 gap-[var(--spacing-xl)]">
          {}
          <div className="relative">
            {}
            <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-muted">
              <div className="w-full bg-accent transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
              height: section3Visible ? "100%" : section2Visible ? "60%" : section1Visible ? "30%" : "0%"
            }} />
            </div>

            {}
            <div className="space-y-[var(--spacing-xl)] pl-[var(--spacing-lg)]">
              <div ref={section1Ref} data-index={0} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${section1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} onMouseEnter={() => setHoveredIndex(0)} onMouseLeave={() => setHoveredIndex(null)}>
                <div className="relative">
                  <div className="absolute -left-[var(--spacing-lg)] top-0 w-3 h-3 rounded-full bg-accent border-2 border-background" />
                  <div className={`text-sm font-semibold mb-[var(--spacing-sm)] transition-colors duration-[var(--duration-fast)] ${hoveredIndex === 0 ? "text-secondary" : "text-muted-foreground"}`}>2021</div>
                  <div className={`overflow-hidden rounded-[var(--radius-sm)] border border-border shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${hoveredIndex === 0 ? "scale-[1.02] shadow-medium" : ""}`}>
                    <img src="https://wimcodigital.com/wp-content/uploads/2026/02/Screenshot-2023-02-09-at-6.08.20-PM-scaled.png" alt="Methane capture site infrastructure" className="w-full h-64 object-cover" />
                  </div>
                </div>
              </div>

              <div ref={section2Ref} data-index={1} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${section2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
              transitionDelay: "100ms"
            }} onMouseEnter={() => setHoveredIndex(1)} onMouseLeave={() => setHoveredIndex(null)}>
                <div className="relative">
                  <div className="absolute -left-[var(--spacing-lg)] top-0 w-3 h-3 rounded-full bg-accent border-2 border-background" />
                  <div className={`text-sm font-semibold mb-[var(--spacing-sm)] transition-colors duration-[var(--duration-fast)] ${hoveredIndex === 1 ? "text-secondary" : "text-muted-foreground"}`}>2022</div>
                  <div className={`overflow-hidden rounded-[var(--radius-sm)] border border-border shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${hoveredIndex === 1 ? "scale-[1.02] shadow-medium" : ""}`}>
                    <img src="https://calm-primate.10web.cloud/wp-content/uploads/2026/02/asic.png" alt="Immersion-cooled server array" className="w-full h-64 object-cover" />
                  </div>
                </div>
              </div>

              <div ref={section3Ref} data-index={2} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${section3Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
              transitionDelay: "200ms"
            }} onMouseEnter={() => setHoveredIndex(2)} onMouseLeave={() => setHoveredIndex(null)}>
                <div className="relative">
                  <div className="absolute -left-[var(--spacing-lg)] top-0 w-3 h-3 rounded-full bg-accent border-2 border-background" />
                  <div className={`text-sm font-semibold mb-[var(--spacing-sm)] transition-colors duration-[var(--duration-fast)] ${hoveredIndex === 2 ? "text-secondary" : "text-muted-foreground"}`}>
                    {timelineData[2].year}
                  </div>
                  <div className={`overflow-hidden rounded-[var(--radius-sm)] border border-border shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${hoveredIndex === 2 ? "scale-[1.02] shadow-medium" : ""}`}>
                    <img src="https://calm-primate.10web.cloud/wp-content/uploads/2026/02/shutterstock_1696487254-scaled.jpg" alt="Modern trading desk operations" className="w-full h-64 object-cover" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="space-y-[var(--spacing-lg)]">
            <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${section1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
              <h3 className="font-display font-semibold text-[clamp(1.5rem,3.5vw,2.25rem)] leading-[1.4] mb-[var(--spacing-sm)] text-foreground">
                {timelineData[0].title}
              </h3>
              <p className="leading-[1.6] text-muted-foreground">
                {timelineData[0].description}
              </p>
            </div>

            <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${section2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: "100ms"
          }}>
              <h3 className="font-display font-semibold text-[clamp(1.5rem,3.5vw,2.25rem)] leading-[1.4] mb-[var(--spacing-sm)] text-foreground"><br /><br /><br /><br />Infrastructure Evolution</h3>
              <p className="leading-[1.6] text-muted-foreground">
                {timelineData[1].description}
              </p>
            </div>

            <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${section3Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: "200ms"
          }}>
              <h3 className="font-display font-semibold text-[clamp(1.5rem,3.5vw,2.25rem)] leading-[1.4] mb-[var(--spacing-sm)] text-foreground"><br /><br />Strategic Expansion</h3>
              <p className="leading-[1.6] text-muted-foreground">
                {timelineData[2].description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}